export default {
  //apiUrl: "http://localhost:5000/api",
  //apiUrl: "https://uatapi.paratic.com.tr/api",
  apiUrl: "https://finekraapi.kirgaz.com.tr/api",
  //apiUrl: "https://finekraapi.kirgaz.com.tr/api",
  headers: {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  },
  //demoUrl: "https://localhost:44351/",
  demoUrl: "https://finekra.kirgaz.com.tr/",
  //demoUrl: "https://www.finekra.com/",
  //frontEndUrl: "http://localhost:3000/",
  // frontEndUrl: "https://panel.paratic.com.tr/",
  //frontEndUrl: "https://ykb.finekra.com/",
  frontEndUrl: "https://finekra.kirgaz.com.tr/",
  //supportPanelImgUrl: "https://localhost:44391",
  supportPanelImgUrl: "https://finekraapi.kirgaz.com.tr",
  renderNotifications: false,
};
